

































import Vue from 'vue';

import {
  FAKE_MOVIES,
  FEATURE,
} from '../config';
import MovieFeature from '../components/ui/features/movie-feature.vue';
import ShowCards from '../components/ui/show-cards/show-cards.vue';

export default Vue.extend({
  name: 'Home',

  components: {
    MovieFeature,
    ShowCards,
  },

  data: () => ({
    feature: FEATURE,
    movies: FAKE_MOVIES,
  }),
});
